// extracted by mini-css-extract-plugin
export var orderSummary = "_tj-0";
export var showMoreLessButton = "_tj-1";